<template>
    <div>
        <Form :model="formData" :label-width="120" ref="form">
            <FormItem label="报价开始日期" :rules="required" prop="startDate">
                <DatePicker style="width:100%" type="date" v-model="formData.startDate"></DatePicker>
            </FormItem>
            <FormItem label="报价结束日期" :rules="required" prop="endDate">
                <DatePicker style="width:100%" type="date" v-model="formData.endDate"></DatePicker>
            </FormItem>
            <FormItem label="库内毛利率" :rules="required" prop="warehouseGpm">
                <Input type="number" v-model="formData.warehouseGpm">
                    <div slot="suffix" style="margin-top:8px">%</div>
                </Input>
            </FormItem>
            <FormItem label="尾程毛利率" :rules="required" prop="tailGpm">
                <Input type="number" v-model="formData.tailGpm">
                    <div slot="suffix" style="margin-top:8px">%</div>
                </Input>
            </FormItem>
            <FormItem label="附件上传" :rules="required" prop="filename">
                <Button type="success" @click="importExcel">选择文件</Button>
                <Button type="gray" class="margin-left-10" @click="clearExcel">清空文件</Button>
                <div>{{formData.filename}}</div>
            </FormItem>
            <FormItem label="备注">
                <Input v-model="formData.remark"></Input>
            </FormItem>
        </Form>
        <div class="text-right margin-bottom-15">
            <Button type="primary" @click="submit">确定</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>

        <!-- 使用公共弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="modalProps={}"
		>
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on" @on-close="modalProps={}"></component>
        </compModal>

        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { HttpGetCustomerPriceOneDetail,HttpSaveCustomerPriceOneDetail } from '@/service/product';
export default {
    props:['id','headId','type'],
    components: {
		// compUpload: () => import("@components/templates/upload"),
        compMutiUpload: () => import("@components/templates/mutiUpload")
	},
    data(){
        return {
            formData:{
                attachment:[],
                filename:'',
            },
            required: [{
                required: true,
                message: this.$t('global.common.fill_requiredd',{defaultValue:'该信息不能为空,请填写'})
            }],
            loading:false,
            modalProps:{},
            titlearr:[],
        }
    },
    created(){
        if(this.type == 'edit'){
            HttpGetCustomerPriceOneDetail({
                id:this.id
            }).then(res=>{
                this.formData = res.data;
                res.data.attachment.map((item) => {
                    this.titlearr.push(item.name);
                })
                this.formData.filename = this.titlearr.join(',');
            },err=>{
                this.$Message.error({
                    content:err.message,
                    duration:10,
                    closable:true,
                })
            })
        }
    },
    methods:{
        async submit(){
            let valid = await this.$refs['form'].validate();
            if (!valid) return;
            this.formData.startDate = this.handleDateFormat(this.formData.startDate, 'yy-mm-dd')
            this.formData.endDate = this.handleDateFormat(this.formData.endDate, 'yy-mm-dd')
            // 保存并新增
            HttpSaveCustomerPriceOneDetail({
                id:this.id,
                headId:this.headId,
                ...this.formData
            }).then(res=>{

                this.$emit('on-row',this.formData);
                this.cancel()
            },err=>{
                this.$Message.error({
                    content:err.message,
                    duration:10,
                    closable:true,
                })
            })
        },
        importExcel(){
            this.modalProps = {
				show: true,
                showFooter:false,
				title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
				component: "compMutiUpload",
				width: 500,
                data: { 
                    srcLabel: this.orderid||0,
                    model: "logistics",
                    type: "other"
                },
                action: process.env.VUE_APP_APIURL_UC + '/api/v1/BizAttach/uploadFile',
                name: "multipartFile",
				on: {
					'on-success': (row) => {
                        let arrnew = row.items.map(item=>{
                            return {
                                name:item.attachTitle,
                                url:item.attachUrl
                            }
                        });
                        this.formData.attachment = [...this.formData.attachment,...arrnew]
                        row.items.map((item) => {
                            this.titlearr.push(item.attachTitle);
                        })
                        this.formData.filename = this.titlearr.join(',');
                        this.modalProps.show = false;
					}
				},
			}
        },
        clearExcel(){
            this.formData.attachment = [];
            this.$set(this.formData,'filename','');
        },
        cancel(){
            this.$emit('on-close')
        },
        
    },
    
}
</script>